"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletSubmissionStep = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class WalletSubmissionStep {
  constructor(data, index) {
    (0, _defineProperty2.default)(this, "index", void 0);
    (0, _defineProperty2.default)(this, "created", void 0);
    (0, _defineProperty2.default)(this, "ended", void 0);
    (0, _defineProperty2.default)(this, "error", void 0);
    (0, _defineProperty2.default)(this, "events", void 0);
    (0, _defineProperty2.default)(this, "id", void 0);
    (0, _defineProperty2.default)(this, "address", void 0);
    (0, _defineProperty2.default)(this, "network", void 0);
    (0, _defineProperty2.default)(this, "status", void 0);
    (0, _defineProperty2.default)(this, "transactionHash", void 0);
    (0, _defineProperty2.default)(this, "from", void 0);
    (0, _defineProperty2.default)(this, "type", void 0);
    (0, _defineProperty2.default)(this, "notice", void 0);
    (0, _defineProperty2.default)(this, "waitForAsset", void 0);
    Object.assign(this, data);
    this.index = index;
  }
  pending() {
    return this.status !== "completed" && this.status !== "error";
  }
  completed() {
    return this.status === "completed";
  }
  pendingConfirmation() {
    // Wallet transactions are never waiting for confirmation
    return false;
  }
}
exports.WalletSubmissionStep = WalletSubmissionStep;
//# sourceMappingURL=WalletSubmissionStep.js.map